<template>
    <div style="height: 100%">
       {{ moment(params.value).format('DD/MM/YYYY HH:mm')}}
    </div>
</template>
<script>
    import Vue from "vue";

    export default Vue.extend({
    });

</script>
